import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonuses } from '../../data/content';
import { SectionCta } from '../SectionCta';
export function Bonuses() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-100" data-mp="1hig2vkby5gjo">
      <div className="mx-auto max-w-5xl" data-id="element-101" data-mp="1clpjoo4ui4u1">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-teal-600" data-id="element-102" data-mp="18jkqtrm81c8g">
          🎁 Exclusive bonuses — free
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy-800 sm:text-4xl" data-id="element-103" data-mp="259bp81xmvjjj">
          Today you'll also get these{' '}
          <em className="italic text-teal-600" data-id="element-104" data-mp="1w8niztehenh7">5 exclusive bonuses free</em>
        </h2>
        <p className="mt-4 text-center text-[15px] font-semibold text-navy-700/80 sm:text-base" data-id="element-105" data-mp="1rac9jjs3mezi">
          $197 total value — included FREE with your purchase today.
        </p>

        <div className="mt-10 flex flex-col gap-6" data-id="element-106" data-mp="krnk2exmpae7">
          {bonuses.map(bonus => <article key={bonus.label} className="overflow-hidden rounded-3xl border border-navy-100 bg-white shadow-[0_2px_12px_rgba(13,34,64,0.05)]" data-id="element-107" data-mp="fx04j5klrqbr">
              <img src={bonus.image} alt={`${bonus.title} — ${bonus.label} mockup`} className="block w-full bg-white" width={1280} height={1280} loading="lazy" data-id="element-108" data-mp="1jqnhok6mcgef" />
              <div className="p-5 sm:p-7" data-id="element-109" data-mp="w2dqf2qmz0fw">
                <div className="flex flex-wrap items-center gap-2" data-id="element-110" data-mp="10tvqloku4wzt">
                  <span className="rounded-full bg-navy-800 px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-111" data-mp="10v6tznadc2qe">
                    🎁 {bonus.label}
                  </span>
                  <span className="rounded-full bg-grass-500/12 px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.12em] text-grass-600" data-id="element-112" data-mp="r4c84k11b55h">
                    Value: {bonus.value} — free today
                  </span>
                </div>

                <h3 className="mt-4 font-display text-2xl font-bold leading-tight text-navy-800 sm:text-[28px]" data-id="element-113" data-mp="2jt3fo4j0yfz2">
                  {bonus.title}
                </h3>
                <p className="mt-3 text-[14px] leading-relaxed text-navy-700/80 sm:text-[15px]" data-id="element-114" data-mp="2f00izniyaqen">
                  {bonus.description}
                </p>

                {bonus.includes && <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-115" data-mp="25z2ez58iiiw2">
                    {bonus.includes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-116" data-mp="2ypueabkvjnnm">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grass-500" aria-hidden="true" data-id="element-117" data-mp="2ynq276ctnic9" />
                        <span className="text-[14px] leading-snug text-navy-700/85" data-id="element-118" data-mp="2or512w3xardp">{item}</span>
                      </li>)}
                  </ul>}
              </div>
            </article>)}
        </div>

        <SectionCta label="Get all 5 bonuses free" data-id="element-119" data-mp="1392voggo96nu" />
      </div>
    </section>;
}